import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

interface ChatMessage {
  text: string;
  isUser: boolean;
  timestamp: Date;
}

@Component({
  selector: 'app-chat-assistant',
  templateUrl: './chat-assistant.component.html',
  styleUrls: ['./chat-assistant.component.scss']
})
export class ChatAssistantComponent implements OnInit {

  isOpen = false;
  isLoading = false;
  messages: ChatMessage[] = [];
  currentMessage = '';
  private sessionId = '';

  private readonly webhookUrl = 'https://n8n.homelab-cer.duckdns.org/webhook/d2d368cf-d445-44ce-9c5c-8157d9761c46';
  private readonly apiKey = 'qbDC0YeCwG-ljgIE0tvrmr02V1wpa0elOvGjVgLfR9GMZN5340CN53hipUncnNDraxQaUb8d8dYmW0BUWe-OBz92N4bWL5685jvO8sXvqZvgHq1AWFUlTku1?!3LW?t!wAGgEAUE8URKZSVKTM6oIIN4Llepv9x3wKKcHPlfY=ej0e?Yhjq-8sf1ru9AgHlyX4TFMSNAoFPHmlILKctD7iWfyjfon0RniNIUIAD/Oubdt?k3YdZf9kzG0mUIdAC3';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.sessionId = this.generateSessionId();
    this.addWelcomeMessage();
  }

  toggleChat(): void {
    this.isOpen = !this.isOpen;
  }

  private addWelcomeMessage(): void {
    this.messages.push({
      text: '¡Hola! Soy tu asistente inmobiliario. ¿En qué puedo ayudarte?',
      isUser: false,
      timestamp: new Date()
    });
  }

  sendMessage(): void {
    if (!this.currentMessage.trim() || this.isLoading) return;

    const userMessage = this.currentMessage.trim();

    // Add user message
    this.messages.push({
      text: userMessage,
      isUser: true,
      timestamp: new Date()
    });

    this.currentMessage = '';
    this.isLoading = true;

    // Call n8n webhook
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-Key': this.apiKey
    });

    const payload = {
      sessionId: this.sessionId,
      action: "chat",
      message: userMessage
    };

    this.http.post(this.webhookUrl, payload, { headers }).subscribe({
      next: (response: any) => {
        this.isLoading = false;

        const botResponseText = response[0]?.output || 'Lo siento, no pude procesar tu mensaje.'; // Uso de optional chaining (?.) para mayor seguridad

        // Add bot response
        this.messages.push({
          text: botResponseText,
          isUser: false,
          timestamp: new Date()
        });

        this.scrollToBottom();
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error calling n8n webhook:', error);

        this.messages.push({
          text: 'Lo siento, ha ocurrido un error. Por favor, inténtalo de nuevo.',
          isUser: false,
          timestamp: new Date()
        });

        this.scrollToBottom();
      }
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      const messagesContainer = document.querySelector('.chat-messages');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }, 100);
  }

  private generateSessionId(): string {
    return 'chat_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }
}